import _ from "lodash";

export default {
    methods: {
        productPrice(product, prefix = 'A partir de ') {
            let unitaryValue = product.unitary_value
            let totalValue = 0
            let showPrefix = false

            if (product.attributes) {
                //Filtra os atributos que são obrigatórios e seus respectivos valores que estão disponíveis para venda
                let requiredAttributes = product.attributes.filter(item => !item.flg_optional).map(item => item.values.filter(value => value.available_for_sale))

                //Se o produto possuir atributos obrigatórios então deve existir o prefixo e calcular a soma do menor valor dos atributos
                if (requiredAttributes.length > 0) {
                    showPrefix = true
                    totalValue = _.sumBy(requiredAttributes.filter(item => item.length > 0)
                      .map(item => _.minBy(item, (i) => parseFloat(i.unitary_value))), function (item) {
                        return parseFloat(item.unitary_value)
                      })
                }
            }

            return this.formatMoney(unitaryValue + totalValue, showPrefix ? prefix : '')
        }
    }
}